// shared/guards/DeveloperGuard.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';

interface DeveloperGuardProps {
  children: React.ReactNode;
  fallback?: string;
}

/**
 * Guard qui protège les routes en mode développeur uniquement
 * Vérifie process.env.NODE_ENV === 'development'
 */
export const DeveloperGuard: React.FC<DeveloperGuardProps> = ({
  children,
  fallback = '/bord'
}) => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  // En production, on peut aussi vérifier d'autres conditions :
  // - Variable d'environnement spécifique
  // - Feature flag
  // - Rôle utilisateur spécial
  const hasDevAccess = isDevelopment ||
    process.env.REACT_APP_ENABLE_DEV_ROUTES === 'true' ||
    // Optionnel: vérifier si l'utilisateur a un rôle développeur
    // useAuth().user?.roles?.includes('Developer')
    false;

  if (!hasDevAccess) {
    console.warn('Tentative d\'accès à une route développeur en production');
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
};
